import React, { Component } from 'react';
import DashDialog from 'screens/components/basic/DialogHeaderDashboard'
import PosCapital from '../../../../images/TechPOSCapital.png';
import PosReferral from '../../../../images/TechPOSReferral.png';
class CustomerCare extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div id="chart11" className="customerCareBg sm-item">
                <DashDialog text="Customer Care Solutions" nolink />
                <div className='position-relative pb-5'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 border-right'>
                                <h5 className='purpleText m-0 mb-10 bold'>TechPOS Capital</h5>
                                <div className="d-flex">
                                    <div>
                                        <ul className="ml--12px">
                                            <li className="grayText text-left">Business Loans up to $500K</li>
                                            <li className="grayText text-left">Line of credit up to $125K</li>
                                            <li className="grayText text-left">Approved within 24hrs</li>
                                        </ul>
                                    </div>
                                    <div><img src={PosCapital} className="posCapitalImg"/></div>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <h5 className='purpleText m-0 mb-10 bold'>TechPOS Referrals</h5>
                                <div className="d-flex">
                                    <div>
                                        <ul className="ml--12px">
                                            <li className="grayText text-left">1 Successful Referral = 25% off 4 month subscription</li>
                                            <li className="grayText text-left">Note: This reward applies to one business</li>
                                        </ul>
                                    </div>
                                    <div><img src={PosReferral} className="posCapitalImg"/></div>
                                </div>
                            </div>
                        </div>
                        <div className='d-flx justify-content-around mt-1 row'>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6 '>
                                <div className='solutionsandResourcesBg'>
                                    <span><a href="https://techpos.ca/techpos-capital/" className='txtWhiteFontLink' target="_blank">GET APPROVED</a></span>
                                </div>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-6 col-xs-6'>
                                <div className='solutionsandResourcesBg'>
                                    <span>REFERRAL FORM</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerCare;
